import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { useCallback, useEffect, useRef } from 'react';
import useUpdateEffect from './useUpdateEffect';

function useDebounceFn(fn, deps, wait) {
  var _deps = Array.isArray(deps) ? deps : [];

  var _wait = typeof deps === 'number' ? deps : wait || 0;

  var timer = useRef();
  var fnRef = useRef(fn);
  fnRef.current = fn;
  var cancel = useCallback(function () {
    if (timer.current) {
      clearTimeout(timer.current);
    }
  }, []);
  var run = useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    cancel();
    timer.current = setTimeout(function () {
      fnRef.current.apply(fnRef, args);
    }, _wait);
  }, [_wait, cancel]);
  useUpdateEffect(function () {
    run();
    return cancel;
  }, [].concat(_toConsumableArray(_deps), [run]));
  useEffect(function () {
    return cancel;
  }, [cancel]);
  return {
    run: run,
    cancel: cancel
  };
}

export default useDebounceFn;